<ng-container>
  <div style="height: 100%">
    <div class="details">
      @if (!this.isLoading()) {
        <mat-tab-group mat-stretch-tabs>
          @if (statusEvents()?.lastProximity) {
            <mat-tab label="Proximity">
              <ng-template matTabContent>
                <vectronic-details-item header="Transmitter ID">
                  <ng-container>
                    {{ statusEvents().lastProximity?.idSensor?.toString() }}
                  </ng-container>
                </vectronic-details-item>
                <vectronic-details-item header="Acquisition Time">
                  <ng-container>
                    {{
                      statusEvents().lastProximity?.acquisitionTime
                        | date: 'dd MMM yyyy HH:mm:ss' : 'UTC'
                    }}
                  </ng-container>
                </vectronic-details-item>
                <vectronic-details-item header="Alive">
                  <ng-container>
                    {{ statusEvents().lastProximity?.alive ? 'Alive' : 'Dead' }}
                  </ng-container>
                </vectronic-details-item>
              </ng-template>
            </mat-tab>
          }
          @if (statusEvents()?.lastMortalityImplant) {
            <mat-tab label="Mortality Implant">
              <ng-template matTabContent>
                <vectronic-details-item header="Transmitter ID">
                  <ng-container>
                    {{ statusEvents().lastMortalityImplant?.idSensor?.toString() }}
                  </ng-container>
                </vectronic-details-item>
                <vectronic-details-item header="Acquisition Time">
                  <ng-container>
                    {{
                      statusEvents().lastMortalityImplant.acquisitionTime
                        | date: 'dd MMM yyyy HH:mm:ss' : 'UTC'
                    }}
                  </ng-container>
                </vectronic-details-item>
                <vectronic-details-item header="Temperature">
                  <ng-container>
                    {{
                      (statusEvents().lastMortalityImplant.temperature?.toString()
                        | number: '1.1-1') + ' °C'
                    }}
                  </ng-container>
                </vectronic-details-item>
                <vectronic-details-item header="Heart rate">
                  <ng-container>
                    {{ statusEvents().lastMortalityImplant.heartRate?.toString() }}
                  </ng-container>
                </vectronic-details-item>
              </ng-template>
            </mat-tab>
          }
          @if (statusEvents()?.lastSeparation) {
            <mat-tab label="Separation">
              <ng-template matTabContent>
                <vectronic-details-item header="Transmitter ID">
                  <ng-container>
                    {{ statusEvents().lastSeparation.idSensor?.toString() }}
                  </ng-container>
                </vectronic-details-item>
                <vectronic-details-item header="Acquisition Time">
                  <ng-container>
                    {{
                      statusEvents().lastSeparation.acquisitionTime
                        | date: 'dd MMM yyyy HH:mm:ss' : 'UTC'
                    }}
                  </ng-container>
                </vectronic-details-item>
                <vectronic-details-item header="Alive">
                  <ng-container>
                    {{ statusEvents().lastSeparation.alive ? 'Alive' : 'Dead' }}
                  </ng-container>
                </vectronic-details-item>
                <vectronic-details-item header="Received">
                  <ng-container>
                    {{ statusEvents().lastSeparation.received ? 'Received' : 'Not Received' }}
                  </ng-container>
                </vectronic-details-item>
              </ng-template>
            </mat-tab>
          }
          @if (statusEvents()?.lastVaginalImplant) {
            <mat-tab label="Vaginal Implant">
              <ng-template matTabContent>
                <vectronic-details-item header="Transmitter ID">
                  <ng-container>
                    {{ statusEvents().lastVaginalImplant.idSensor?.toString() }}
                  </ng-container>
                </vectronic-details-item>
                <vectronic-details-item header="Acquisition Time">
                  <ng-container>
                    {{
                      statusEvents().lastVaginalImplant.acquisitionTime
                        | date: 'dd MMM yyyy HH:mm:ss' : 'UTC'
                    }}
                  </ng-container>
                </vectronic-details-item>
                <vectronic-details-item header="Activity Level">
                  <ng-container>
                    {{ statusEvents().lastVaginalImplant.activityLevel?.toString() }}
                  </ng-container>
                </vectronic-details-item>
                <vectronic-details-item header="Temperature">
                  <ng-container>
                    {{
                      (statusEvents().lastVaginalImplant.temperature?.toString()
                        | number: '1.1-1') + ' °C'
                    }}
                  </ng-container>
                </vectronic-details-item>
              </ng-template>
            </mat-tab>
          }
          @if (statusEvents()?.lastVirtualFence) {
            <mat-tab label="Virtual Fence">
              <ng-template matTabContent>
                <vectronic-details-item header="Entered in virtual Fence">
                  {{ statusEvents().lastVirtualFence.vfEntered }}
                </vectronic-details-item>
                <vectronic-details-item header="Latitude/Longitude">
                  <ng-container>
                    {{ statusEvents().lastVirtualFence.latitude }} /
                    {{ statusEvents().lastVirtualFence.longitude }}
                  </ng-container>
                </vectronic-details-item>
                <vectronic-details-item header="Acquisition Time">
                  <ng-container>
                    {{
                      statusEvents().lastVirtualFence.acquisitionTime
                        | date: 'dd MMM yyyy HH:mm:ss' : 'UTC'
                    }}
                  </ng-container>
                </vectronic-details-item>
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
        @if (
          (statusEvents()?.lastProximity === null || statusEvents()?.lastProximity === undefined) &&
          (statusEvents()?.lastMortalityImplant === null ||
            statusEvents()?.lastMortalityImplant === undefined) &&
          (statusEvents()?.lastSeparation === null ||
            statusEvents()?.lastSeparation === undefined) &&
          (statusEvents()?.lastVaginalImplant === null ||
            statusEvents()?.lastVaginalImplant === undefined) &&
          (statusEvents()?.lastVirtualFence === null ||
            statusEvents()?.lastVirtualFence === undefined)
        ) {
          <p class="events-status__empty">
            There is no event for proximity, mortality implant, separation, vaginal implant and
            virtual fence.
          </p>
        }
      }
    </div>
    <div class="collar-details__footer"></div>
  </div>
</ng-container>
